(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/help', {
      templateUrl: 'modules/app/help/help.html',
      controller: 'HelpCtrl'
    });
  }]).
  /**
   * Help/Support Email Page
   */
  controller('HelpCtrl', ['$scope', '$http', 'Api', 'User', function ($scope, $http, Api, User) {
    //set header
    $scope.$emit("headline:change", "Help");
    $scope.$emit("nav:change", "help");

    //grab email from log in
    var user = User.get();
    $scope.email = user.user.email;
    $scope.send = function send() {
      var params = {
        'reply-email': $scope.email,
        'user-email': user.user.email,
        'report': $scope.report
      };
      $http.post(Api.url("/help", true), params);
      $scope.submittedForm = true;
    };
  }]);
})();
